// ExamCivilAgentPage.tsx

import { useTranslation } from "react-i18next";
import { AccountBalance, MenuBook, Balance } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getCivilAgentBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("blnst")) {
      const accent = isDark ? "#80BFFF" : "#1e3a8a";
      return {
        icon: Balance,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("cre")) {
      const accent = isDark ? "#60a5fa" : "#1e40af";
      return {
        icon: MenuBook,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#94a3b8" : "#334155";
    return {
      icon: AccountBalance,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamCivilAgentPage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examCivilAgent.title")}
      subtitle={t("pages.examCivilAgent.subtitle")}
      actionText={t("pages.examCivilAgent.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "civilagent", limit: 99 });
        return res.data;
      }}
      brandResolver={getCivilAgentBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
